import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import BackNext from '../../Common/SubComponents/BackNext';
import { Container, Form, Row, Col } from "react-bootstrap";
import { StyledRadioInput, TextInput, SelectInput, DateInput } from "../../../Helpers/Inputs/index";
import SvgIcon from '@material-ui/core/SvgIcon';
import CalenderSchedule from '../icons/calender-schedule.svg';
import Hand from '../icons/Hand.svg';
import GetStateListForAflac from '../Helpers/StateListForAflac';
import { object, string, array as yuparray, mixed, customValidators } from '../../../Helpers/Validators/customValidators';
import { ARIZONA, MARYLAND, COLORADO, OREGON, MAINE } from '../../../Helpers/Constants/States';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles';
import Warning from '../icons/warning.svg';
import moment from "moment";
const useStyles = makeStyles(theme => ({
    tipBox: {
        backgroundColor: alpha(theme.palette.primary.main, .1),
        borderRadius: '10px',
        padding: "12px"
    },
    insideTitle: {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 600,
    },
    insideIcon: {
        height: "24px",
        width: "24px",
        marginBottom: "-7px",
        marginRight: "-8px",
    },
    insideText: {
        fontSize: "14px",
    }
}));

export default function HIVEligibility(props) {

    const classes = useStyles();
    const [dateCalenderOpen, setDateCalenderOpen] = useState(false);
    const { state, hsaAccount } = props.basicInfo;

    const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
        validationSchema: HIVEligibility.ValidationSchema(),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const ineligibleDefault = [
        {
            type: '',
            name: [],
            numberOfChildren: '',
            nameofChildren: [],
        },
    ];
    useEffect(() => {
        props.onFieldChange("isVisible", true);
        if (state === COLORADO && props.formState.hiv === 'Yes' && props.formState.ineligible.length === 0) {
            handleValueChangeWithIneligible('hiv', 'Yes',true)
        }
    }, [])

    useEffect(() => {
        register({ name: 'state' });
        setValue('state', state);

        register({ name: 'aids' });
        setValue('aids', props.formState.aids);

        register({ name: 'hiv' });
        setValue('hiv', props.formState.hiv);
        
        register({ name: 'hivPositive' });
        setValue('hivPositive', props.formState.hivPositive);

        register({ name: 'hivSubstantiated' })
        setValue('hivSubstantiated', props.formState.hivSubstantiated);
        
        register({ name: 'hivSubstantiatedSevenYears' })
        setValue('hivSubstantiatedSevenYears', props.formState.hivSubstantiatedSevenYears);

        register({ name: 'hivPositiveMultispot' });
        setValue('hivPositiveMultispot', props.formState.hivPositiveMultispot);

        register({ name: 'ineligibleForCoverage' })
        setValue('ineligibleForCoverage', props.formState.ineligibleForCoverage);

        register({ name: 'hivTestsPerformed' })
        setValue('hivTestsPerformed', props.formState.hivTestsPerformed);

        register({ name: 'hivPhysicianName' })
        setValue('hivPhysicianName', props.formState.hivPhysicianName);

        register({ name: 'hivPhysicianStreet' })
        setValue('hivPhysicianStreet', props.formState.hivPhysicianStreet);

        register({ name: 'hivPhysicianCity' })
        setValue('hivPhysicianCity', props.formState.hivPhysicianCity);

        register({ name: 'hivPhysicianState' })
        setValue('hivPhysicianState', props.formState.hivPhysicianState);

        register({ name: 'hivPhysicianZip' })
        setValue('hivPhysicianZip', props.formState.hivPhysicianZip);

        register({ name: 'hivReceiptPhysician' })
        setValue('hivReceiptPhysician', props.formState.hivReceiptPhysician);

        register({ name: 'hivReceiptPhysicianName' })
        setValue('hivReceiptPhysicianName', props.formState.hivReceiptPhysicianName);

        register({ name: 'hivReceiptPhysicianStreet' })
        setValue('hivReceiptPhysicianStreet', props.formState.hivReceiptPhysicianStreet);

        register({ name: 'hivReceiptPhysicianCity' })
        setValue('hivReceiptPhysicianCity', props.formState.hivReceiptPhysicianCity);

        register({ name: 'hivReceiptPhysicianState' })
        setValue('hivReceiptPhysicianState', props.formState.hivReceiptPhysicianState);

        register({ name: 'hivReceiptPhysicianZip' })
        setValue('hivReceiptPhysicianZip', props.formState.hivReceiptPhysicianZip);

        register({ name: 'hivTestsDate' })
        setValue('hivTestsDate', props.formState.hivTestsDate);

        props.formState.ineligible.forEach((ineligible, index) => {
            register({ name: `ineligible[${index}].type` });
            setValue(`ineligible[${index}].type`, ineligible.type);

            register({ name: `ineligible[${index}].name` });
            setValue(`ineligible[${index}].name`, ineligible.name);

            register({ name: `ineligible[${index}].numberOfChildren` });
            setValue(`ineligible[${index}].numberOfChildren`, ineligible.numberOfChildren);

            register({ name: `ineligible[${index}].nameofChildren` });
            setValue(`ineligible[${index}].nameofChildren`, ineligible.nameofChildren);
        });

    }, [register])

    const handleValueChangeWithIneligible = (field, value, isInElegible = false) => {
        if(!isInElegible){
            handleValueChange(field, value);
            return;
        }
        setValue(field, value);
        if (value === 'Yes') {
            const newBeneIndex = props.formState.ineligible.length;
            register({ name: `ineligible[${newBeneIndex}].type` });
            register({ name: `ineligible[${newBeneIndex}].name` });
            register({ name: `ineligible[${newBeneIndex}].numberOfChildren` });
            register({ name: `ineligible[${newBeneIndex}].nameofChildren` });
            let newForm = ineligibleDefault;
            newForm[0].type = field;
            props.onStepFieldChange(field, value, 'ineligible', [...props.formState.ineligible, newForm[0]]);
            triggerValidation(field);
        } else {
            props.onStepFieldChange(
                field,
                value,
                'ineligible',
                props.formState.ineligible.filter((form, formIndex) => form.type !== field)
            );
            reset();
        }
    };

    const handleValueChange = (field, value) => {
        if(field === 'hivPositive' && value === "No" && state === ARIZONA){
            let form = {...props.fullFormState};
            form.steps.hivEligibility.hivTestsPerformed = '';
            form.steps.hivEligibility.hivPhysicianCity = '';
            form.steps.hivEligibility.hivPhysicianName = '';
            form.steps.hivEligibility.hivPhysicianStreet = '';
            form.steps.hivEligibility.hivPhysicianState = '';
            form.steps.hivEligibility.hivPhysicianZip = '';
            form.steps.hivEligibility.hivTestsDate = null;
            setValue('hivTestsDate', null);
            form.steps.hivEligibility.hivPositive = value;
            props.onMultiFieldChange(form);
        }
        else{
            props.onFieldChange(field, value);
        }
        setValue(field, value);
        triggerValidation(field);
    };

    const getIneligibleNames = () => {
        return (
            [
                { value: "Name of Proposed Insured", label: "Name of Proposed Insured" },
                { value: "Name of Spouse", label: "Name of Spouse" },
                { value: "Dependent Child", label: "Dependent Child" },
            ]
        )
    }

    const getIneligibleForCoverage = () => {
        return (
            [
                { value: "Proposed Insured", label: "Proposed Insured" },
                { value: "Spouse", label: "Spouse" },
                { value: "Child", label: "Child" },
            ]
        )
    }

    const getImportantNoticeText = () => {
        const formState = props.formState;
        let noticeText = 'To evaluate your insurability, Aflac has requested that you provide a sample of your blood for testing and analysis to determine the presence of human immunodeficiency virus (HIV) antibodies.';
        if ((displayWarning && state === ARIZONA && formState.hiv === 'Yes' && formState.hivPositive === 'Yes') || (state === COLORADO && formState.hiv === 'Yes' && formState.hivPositive === 'No' && formState.hivPositiveMultispot === 'Yes')) {
            noticeText = 'Because you were unable to provide the required information regarding your HIV testing, to evaluate your insurability, Aflac has requested that you provide a sample of your blood for testing and analysis to determine the presence of human immunodeficiency virus (HIV) antibodies.';
        }

        return noticeText;
    }

    const getAidsLabel = () => {
        if (state === MARYLAND) {
            return 'Within the last five years, has anyone to be covered been diagnosed with or treated for known symptoms or known indications of acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or tested positive for human immunodeficiency virus (HIV)?';
        } else if (state === MAINE) {
            return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
        } else {
            return 'Within the last five years, has anyone to be covered been diagnosed with or treated for acquired immune deficiency syndrome (AIDS) by a member of the medical profession, or has anyone to be covered tested positive for human immunodeficiency virus (HIV)?';
        }
    };


    const onSubmit = () => {
        props.onNext();
    };

    const showInEligible = ((props.formState.hiv === 'Yes' && state === COLORADO) || (props.formState.aids === 'Yes' && state === MAINE));
    const inEligibleType = showInEligible ? props.formState.hiv === 'Yes' ? 'hiv' : 'aids' : '';
    const displayWarning = (!props.formState.hivTestsPerformed || !props.formState.hivPhysicianName || !props.formState.hivPhysicianStreet || !props.formState.hivPhysicianCity ||  !props.formState.hivPhysicianState || !props.formState.hivPhysicianZip || !props.formState.hivTestsDate);

    const getIneligibleComponent = (field, list) => {
        let item;
        list.map((ineligible, index) => {
            if (ineligible.type === field) {
                item = ineligible;
                item.index = index;
            }
        });
        const handleValueChangeloop = (field, type, value, longFieldName) => {
            setValue(longFieldName, value);
            props.onFieldChange(
                'ineligible',
                props.formState.ineligible.map((form, formIndex) => {
                    if (type === form.type) {
                        if (field === "name")
                            form[field] = value;
                        else
                            eval('form.' + field + '=' + `'${value}'`);
                        return form;
                    } else {
                        return form;
                    }
                })
            );
        };
        const handleChildrenNames = (field, type, value, longFieldName) => {
            setValue(longFieldName, value);

            props.onFieldChange(
                'ineligible',
                props.formState.ineligible.map((form, formIndex) => {
                    if (type === form.type) {
                        if (field === 'numberOfChildren') {
                            eval('form.' + field + '=' + `'${value}'`);
                            const previousChildLength = form.nameofChildren.length;
                            const totalChild = parseInt(value);
                            if ((totalChild > previousChildLength, totalChild)) {
                                const addChildInput = totalChild - previousChildLength;
                                for (let i = 1; i <= addChildInput; i++) {
                                    if (type === form.type) {
                                        form.nameofChildren.push({ name: '' });
                                    }
                                }
                            } else {
                                const removeChildInput = previousChildLength - totalChild;
                                form.nameofChildren.splice(`-${removeChildInput}`);
                            }
                            reset();
                            return form;
                        }
                    } else {
                        if (type === form.type) {
                            eval('form.' + field + '=' + `'${value}'`);
                            return form;
                        } else {
                            return form;
                        }
                    }
                })
            );
        };

        return (
            <div>
            {item && 
                <IneligibleForm
                    formState={item}
                    onChange={(field, value, type, longFieldName) => {
                        handleValueChangeloop(field, type, value, longFieldName);
                    }}
                    ChildChange={(field, value, type, longFieldName) => {
                        handleChildrenNames(field, type, value, longFieldName);
                    }}
                    allProps={props}
                    setValue={setValue}
                    trigger={triggerValidation}
                    key={item.index}
                    index={item.index}
                    register={register}
                    errors={errors.ineligible && errors.ineligible[item.index]}
                    customOption={props.getListOfPlanIncludedPerson()}
                    noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
                />
            }
            </div>
        );
    };
    return (
        <Container className="border-class" fluid>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center mt-4">
                    <Col lg={5}>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={Hand} className="small-icons" color="primary" fontSize="large" /></div>
                        <div className="text-center mb-4 form-title">HIV Eligibility</div>
                    </Col>
                </Row>
                <Row className="hiv-eligibility justify-content-center">
                    <Col className='col-div'>
                        {
                            state === ARIZONA &&
                            (<Form.Group>
                                <h6 className='pb-2'>Has anyone to be covered ever tested positive for human immunodeficiency virus (HIV)?</h6>
                                <StyledRadioInput
                                    name="hiv"
                                    id="hiv"
                                    value={props.formState.hiv}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={(e) => handleValueChangeWithIneligible('hiv', e)}
                                    errors={errors && errors.hiv}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>)
                        }
                        {
                            state === COLORADO &&
                            <Form.Group>
                                <h6 className='pb-2'>Has anyone to be covered ever tested positive for the human immunodeficiency virus (HIV) or HTLV-III (antibodies or human T-lymphotropic virus Type II)?</h6>
                                <StyledRadioInput
                                    name="hiv"
                                    id="hiv"
                                    value={props.formState.hiv}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={(e) => handleValueChangeWithIneligible('hiv', e, true)}
                                    errors={errors && errors.hiv}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }
                        {
                            (state === MARYLAND || state === MAINE || state === OREGON) &&
                            <React.Fragment>
                                {state === MAINE && (
                                    <div className="hiv-quote">
                                        *ANSWER THIS QUESTION “NO” IF YOU HAVE TESTED POSITIVE FOR HIV AND HAVE NOT DEVELOPED SYMPTOMS OF THE DISEASE AIDS.*
                                    </div>
                                )}
                                <Form.Group>
                                    <h6>{getAidsLabel()}</h6>
                                    <StyledRadioInput
                                        name="aids"
                                        id="aids"
                                        value={props.formState.aids}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={(e) => handleValueChangeWithIneligible('aids', e, state === MAINE)}
                                        errors={errors && errors.aids}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                            </React.Fragment>
                        }
                        {showInEligible && getIneligibleComponent(inEligibleType, props.formState.ineligible)}

                        {state === ARIZONA && props.formState.hiv === 'Yes' &&
                            <Form.Group>
                                <h6 className='pb-2'>Have you had tests confirming the positive HIV test result or diagnosis such as a second positive screening test (the ELISA test) and a positive supplemental test (the Western Blot test)?</h6>
                                <StyledRadioInput
                                    name="hivPositive"
                                    id="hivPositive"
                                    value={props.formState.hivPositive}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={(e) => handleValueChange('hivPositive', e)}
                                    errors={errors && errors.hivPositive}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }

                        {((props.formState.hiv === 'Yes' && state === COLORADO) || ((state === MARYLAND || state === OREGON) && props.formState.aids === "Yes")) &&
                            <Form.Group>
                                <h6 className='pb-2'>{`Has the result been substantiated by two ELISA or EIA tests and one Western Blot Blood Test${state !== OREGON ? ' or one HIV 1/2 Multispot test' : ''}?`}</h6>
                                <StyledRadioInput
                                    name="hivSubstantiated"
                                    id="hivSubstantiated"
                                    value={props.formState.hivSubstantiated}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('hivSubstantiated', e)}
                                    errors={errors && errors.hivSubstantiated}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }

                        {state === COLORADO && props.formState.hivSubstantiated === 'No' &&
                            <Form.Group>
                                <h6 className='pb-2'>Have you had tests confirming the positive HIV test result or diagnosis such as a second positive screening test (the ELISA test) and a positive supplemental test (the Western Blot test or HIV 1/2 Multispot test)?</h6>
                                <StyledRadioInput
                                    name="hivPositiveMultispot"
                                    id="hivPositiveMultispot"
                                    value={props.formState.hivPositiveMultispot}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('hivPositiveMultispot', e)}
                                    errors={errors && errors.hivPositiveMultispot}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }

                        {state === MARYLAND && props.formState.hivSubstantiated === 'Yes' &&
                            <Form.Group>
                                <h6 className='pb-2'>Have you had a positive test result substantiated by two ELISA tests and a Western Blot test in the past seven years?</h6>
                                <StyledRadioInput
                                    name="hivSubstantiatedSevenYears"
                                    id="hivSubstantiatedSevenYears"
                                    value={props.formState.hivSubstantiatedSevenYears}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleValueChange('hivSubstantiatedSevenYears', e)}
                                    errors={errors && errors.hivSubstantiatedSevenYears}
                                    isWhiteBackground={true}
                                    isBlankIcon={true}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }

                        {(props.formState.hiv === "Yes" && (props.formState.hivSubstantiated === "Yes" && state !== COLORADO)) &&
                            <Fragment>
                                <Form.Group hidden>
                                    <h6 className='pb-2'>If any one of Questions 1 through 8 is answered yes, was it the:</h6>
                                    <SelectInput
                                        name="ineligibleForCoverage"
                                        id="ineligibleForCoverage"
                                        value={props.formState.ineligibleForCoverage}
                                        onChange={e => handleValueChange('ineligibleForCoverage', e.target.value)}
                                        label="If Yes, Who:"
                                        selectOptions={getIneligibleForCoverage()}
                                        errors={errors && errors.ineligibleForCoverage}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group hidden>
                                    <h6 className='pb-2'>Any person(s) indicated above will not be covered under the policy and/or rider(s).  If the named person is the Proposed Insured, a policy and/or rider(s) will not be issued; therefore, do not submit this application.</h6>
                                    <SelectInput
                                        name="ineligibleNames"
                                        id="ineligibleNames"
                                        value={props.formState.ineligibleNames}
                                        onChange={e => handleValueChange('ineligibleNames', e.target.value)}
                                        // label="If Yes, Who:"
                                        selectOptions={getIneligibleNames()}
                                        errors={errors && errors.ineligibleNames}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            </Fragment>
                        }
                        <Form.Group hidden>
                            <h6 className='pb-2'>If a child, are any other children to be covered?</h6>
                            <StyledRadioInput
                                name="anotherChild"
                                id="anotherChild"
                                value={props.formState.anotherChild}
                                options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                onChange={e => handleValueChange('anotherChild', e)}
                                errors={errors && errors.anotherChild}
                                isWhiteBackground={true}
                                isBlankIcon={true}
                                inputRef={register}
                            />
                        </Form.Group>
                        {((props.formState.hiv === "Yes" && ((props.formState.hivPositive === "Yes" && state === ARIZONA) || (props.formState.hivSubstantiated === "Yes" && state !== COLORADO) || (props.formState.hivSubstantiated === "No" && props.formState.hivPositiveMultispot === 'Yes' && state === COLORADO))) || (props.formState.aids === 'Yes' && (state === MARYLAND && props.formState.hivSubstantiated === 'Yes' && props.formState.hivSubstantiatedSevenYears === 'Yes') || (state === OREGON && props.formState.hivSubstantiated === 'Yes'))) &&
                            <Fragment>
                                <Form.Group>
                                    <TextInput
                                        name="hivTestsPerformed"
                                        id="hivTestsPerformed"
                                        label="What confirmatory tests were performed?"
                                        value={props.formState.hivTestsPerformed}
                                        errors={errors && errors.hivTestsPerformed}
                                        onChange={(e) => handleValueChange('hivTestsPerformed', e.target.value)}
                                        inputRef={register}
                                        multiline
                                        rows={6}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <h6 className='pb-2'>Please provide the name and address of the doctor or laboratory that performed the tests.</h6>
                                    <h6 className='pb-2'>Physician</h6>
                                    <TextInput
                                        name="hivPhysicianName"
                                        id="hivPhysicianName"
                                        label="Name"
                                        value={props.formState.hivPhysicianName}
                                        errors={errors && errors.hivPhysicianName}
                                        onChange={(e) => handleValueChange('hivPhysicianName', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivPhysicianStreet"
                                        id="hivPhysicianStreet"
                                        label="Street Address"
                                        value={props.formState.hivPhysicianStreet}
                                        errors={errors && errors.hivPhysicianStreet}
                                        onChange={(e) => handleValueChange('hivPhysicianStreet', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivPhysicianCity"
                                        id="hivPhysicianCity"
                                        label="City"
                                        value={props.formState.hivPhysicianCity}
                                        errors={errors && errors.hivPhysicianCity}
                                        onChange={(e) => handleValueChange('hivPhysicianCity', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <SelectInput
                                        name="hivPhysicianState"
                                        id="hivPhysicianState"
                                        value={props.formState.hivPhysicianState}
                                        onChange={e => handleValueChange('hivPhysicianState', e.target.value)}
                                        label="State"
                                        selectOptions={GetStateListForAflac()}
                                        errors={errors && errors.hivPhysicianState}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivPhysicianZip"
                                        id="hivPhysicianZip"
                                        label="Zip"
                                        value={props.formState.hivPhysicianZip}
                                        errors={errors && errors.hivPhysicianZip}
                                        onChange={(e) => handleValueChange('hivPhysicianZip', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <h6 className='pb-2'>When were these tests performed?</h6>
                                    <DateInput
                                        calenderOpen={dateCalenderOpen}
                                        setCalenderOpen={setDateCalenderOpen}
                                        autoOk
                                        variant="inline"
                                        disableToolbar
                                        inputVariant="filled"
                                        name="hivTestsDate"
                                        id="hivTestsDate"
                                        label="Date tests were performed."
                                        format="MMMM D, YYYY"
                                        value={props.formState.hivTestsDate}
                                        onChange={value => handleValueChange('hivTestsDate', value)}
                                        maxDate={moment().add(0, 'days')}
                                        inputRef={register}
                                        fullWidth
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        keyboardIcon={<SvgIcon component={CalenderSchedule} />}
                                        errors={errors && errors.hivTestsDate}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Form.Group>
                            </Fragment>
                        }
                        {
                            (((props.formState.hivPositive  && state === ARIZONA) && props.formState.hiv === "Yes") || ((props.formState.hivSubstantiated === "No" && state !== COLORADO) && props.formState.hiv === "Yes") || ((state === OREGON || state === MARYLAND) && props.formState.aids === "Yes" && ((props.formState.hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && props.formState.hivSubstantiated === "Yes" && props.formState.hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && props.formState.aids === "No") || (state === COLORADO && props.formState.hivSubstantiated === 'No' && props.formState.hivPositiveMultispot === 'No')) &&
                            <Fragment>
                                {(!displayWarning && state === ARIZONA) ? null :
                                    <Row>
                                        <p className={`${classes.tipBox} mx-3`}>
                                            <b className={classes.insideTitle}>
                                                <SvgIcon component={Warning} fontSize="large" className={classes.insideIcon} />
                                                Important:{' '}
                                            </b>
                                            <b className={classes.insideText}>{getImportantNoticeText()}</b>
                                        </p>
                                    </Row>
                                }
                                <Form.Group>
                                    <h6 className='pb-2'>Would you like to designate a Physician for receipt of your test results if positive?</h6>
                                    <StyledRadioInput
                                        name="hivReceiptPhysician"
                                        id="hivReceiptPhysician"
                                        value={props.formState.hivReceiptPhysician}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('hivReceiptPhysician', e)}
                                        errors={errors && errors.hivReceiptPhysician}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                            </Fragment>
                        }

                        {((props.formState.hivSubstantiated === "No" && props.formState.hiv === "Yes") || ((state === OREGON || state === MARYLAND) && props.formState.aids === "Yes" && ((props.formState.hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && props.formState.hivSubstantiated === "Yes" && props.formState.hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && props.formState.aids === "No") || (props.formState.hiv === "Yes" && state === ARIZONA)) && props.formState.hivReceiptPhysician === "Yes"  &&
                            <Fragment>
                                <h6 className='pb-2'>Physician </h6>
                                <Form.Group>
                                    <TextInput
                                        name="hivReceiptPhysicianName"
                                        id="hivReceiptPhysicianName"
                                        label="Name"
                                        value={props.formState.hivReceiptPhysicianName}
                                        errors={errors && errors.hivReceiptPhysicianName}
                                        onChange={(e) => handleValueChange('hivReceiptPhysicianName', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivReceiptPhysicianStreet"
                                        id="hivReceiptPhysicianStreet"
                                        label="Street Address"
                                        value={props.formState.hivReceiptPhysicianStreet}
                                        errors={errors && errors.hivReceiptPhysicianStreet}
                                        onChange={(e) => handleValueChange('hivReceiptPhysicianStreet', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivReceiptPhysicianCity"
                                        id="hivReceiptPhysicianCity"
                                        label="City"
                                        value={props.formState.hivReceiptPhysicianCity}
                                        errors={errors && errors.hivReceiptPhysicianCity}
                                        onChange={(e) => handleValueChange('hivReceiptPhysicianCity', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <SelectInput
                                        name="hivReceiptPhysicianState"
                                        id="hivReceiptPhysicianState"
                                        value={props.formState.hivReceiptPhysicianState}
                                        onChange={e => handleValueChange('hivReceiptPhysicianState', e.target.value)}
                                        label="State"
                                        selectOptions={GetStateListForAflac()}
                                        errors={errors && errors.hivReceiptPhysicianState}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="hivReceiptPhysicianZip"
                                        id="hivReceiptPhysicianZip"
                                        label="Zip"
                                        value={props.formState.hivReceiptPhysicianZip}
                                        errors={errors && errors.hivReceiptPhysicianZip}
                                        onChange={(e) => handleValueChange('hivReceiptPhysicianZip', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            </Fragment>
                        }
                    </Col>
                </Row>
                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                </div>
            </form>
        </Container >

    );
}

HIVEligibility.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

HIVEligibility.ValidationSchema = () => {
    return object().shape({
        hiv: string().when('state', {
            is: (state) => state === ARIZONA || state === COLORADO,
            then: string().required("This field is required"),
            otherwise: string().notRequired()
        }),
        aids: string().when('state', {
            is: (state) => state === MAINE || state === MARYLAND || state === OREGON,
            then: string().required('This field is required'),
            otherwise: string().notRequired()
        }),
        hivPositive: string().when(['state', 'hiv'], {
            is: (state, hiv) => state === ARIZONA && hiv === 'Yes',
            then: string().required('This field is required'),
            otherwise: string().notRequired()
        }),

        hivSubstantiated: string().when(['hiv', "state", "aids"], {
            is: (hiv, state, aids) => ((hiv === "Yes" && state === COLORADO ) || ((state === MARYLAND || state === OREGON) && aids === "Yes")),
            then: string().required("This field is required"),
            otherwise: string().notRequired()
        }),

        hivPositiveMultispot: string().when(['state', 'hivSubstantiated'], {
            is: (state, hivSubstantiated) => state === COLORADO && hivSubstantiated === 'No',
            then: string().required('This field is required'),
            otherwise: string().notRequired()
        }),

        hivSubstantiatedSevenYears: string().when(['state', 'hivSubstantiated'], {
            is: (state, hivSubstantiated) => state == MARYLAND && hivSubstantiated === 'Yes',
            then: string().required('This field is required'),
            otherwise: string().notRequired()
        }),

        hivReceiptPhysician: string().when(['hivSubstantiated', "state", "aids", "hiv", "hivSubstantiatedSevenYears", "hivPositiveMultispot",'hivPositive'], {
            is: (hivSubstantiated, state, aids, hiv, hivSubstantiatedSevenYears, hivPositiveMultispot, hivPositive) => ((hiv === "Yes" && state === ARIZONA && hivPositive) ||((hivSubstantiated === "No" && state !== COLORADO) && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No") || (state === COLORADO && hivSubstantiated === 'No' && hivPositiveMultispot === 'No')),
            then: string().required("This field is required"),
            otherwise: string().notRequired()
        }),
        hivTestsPerformed: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears', 'hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears, hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes")||(hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: customValidators.string().isValidNameWithFiftyChar('This field is required', true),
            otherwise: string().notRequired()
        }),
        hivTestsDate: mixed().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears, hivPositive) => ((hiv === "Yes" && state === ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: mixed().required("Date is required").test({
                message: "Invalid Date",
                test: (value) => moment(value).isValid()
            }),
            otherwise: mixed().notRequired()
        }),
        hivPhysicianName: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears,hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: customValidators.string().isValidNameWithFiftyChar('Name is required.', true),
            otherwise: string().notRequired()
        }),
        hivPhysicianCity: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears,hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: string().isValidNameLimitedSpecialChar('City is required.', true, false),
            otherwise: string().notRequired()
        }),
        hivPhysicianStreet: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears,hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: customValidators.string().isValidNameLimitedSpecialChar('Street is required.', true, true),
            otherwise: string().notRequired()
        }),
        hivPhysicianState: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears,hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: string().required("State is required"),
            otherwise: string().notRequired()
        }),
        hivPhysicianZip: string().when(["hivSubstantiated", "hiv", 'hivPositiveMultispot', 'state', 'aids', 'hivSubstantiatedSevenYears','hivPositive'], {
            is: (hivSubstantiated, hiv, hivPositiveMultispot, state, aids, hivSubstantiatedSevenYears,hivPositive) => ((hiv === "Yes" && state ===ARIZONA && hivPositive === "Yes") || (hiv === "Yes" && ((hivSubstantiated === "Yes" && state !== COLORADO) || (hivSubstantiated === "No" && hivPositiveMultispot === "Yes" && state === COLORADO))) || (aids === "Yes" && (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === "Yes") || (state === OREGON && hivSubstantiated === "Yes"))),
            then: string().required("Zip is required").matches(/^[0-9]{5}$/, 'Zip code must be 5 number characters.'),
            otherwise: string().notRequired()
        }),
        hivReceiptPhysicianName: string().when(["hivReceiptPhysician", "hivSubstantiated", "hiv", "state", "aids", "hivSubstantiatedSevenYears"], {
            is: (hivReceiptPhysician, hivSubstantiated, hiv, state, aids, hivSubstantiatedSevenYears) => ((hiv === "Yes" && state === ARIZONA) || (hivSubstantiated === "No" && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No")) && hivReceiptPhysician === "Yes",
            then: customValidators.string().isValidNameWithFiftyChar('Name is required.', true),
            otherwise: string().notRequired()
        }),
        hivReceiptPhysicianStreet: string().when(["hivReceiptPhysician", "hivSubstantiated", "hiv", "state", "aids", "hivSubstantiatedSevenYears"], {
            is: (hivReceiptPhysician, hivSubstantiated, hiv, state, aids, hivSubstantiatedSevenYears) => ((hiv === "Yes" && state === ARIZONA) || (hivSubstantiated === "No" && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No")) && hivReceiptPhysician === "Yes",
            then: customValidators.string().isValidNameLimitedSpecialChar('Street is required.', true, true),
            otherwise: string().notRequired()
        }),
        hivReceiptPhysicianCity: string().when(["hivReceiptPhysician", "hivSubstantiated", "hiv", "state", "aids", "hivSubstantiatedSevenYears"], {
            is: (hivReceiptPhysician, hivSubstantiated, hiv, state, aids, hivSubstantiatedSevenYears) => ((hiv === "Yes" && state === ARIZONA) || (hivSubstantiated === "No" && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No")) && hivReceiptPhysician === "Yes",
            then: string().isValidNameLimitedSpecialChar('City is required.', true, false),
            otherwise: string().notRequired()
        }),
        hivReceiptPhysicianState: string().when(["hivReceiptPhysician", "hivSubstantiated", "hiv", "state", "aids", "hivSubstantiatedSevenYears"], {
            is: (hivReceiptPhysician, hivSubstantiated, hiv, state, aids, hivSubstantiatedSevenYears) => ((hiv === "Yes" && state === ARIZONA) || (hivSubstantiated === "No" && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No")) && hivReceiptPhysician === "Yes",
            then: string().required("State is required"),
            otherwise: string().notRequired()
        }),
        hivReceiptPhysicianZip: string().when(["hivReceiptPhysician", "hivSubstantiated", "hiv", "state", "aids", "hivSubstantiatedSevenYears"], {
            is: (hivReceiptPhysician, hivSubstantiated, hiv, state, aids, hivSubstantiatedSevenYears) => ((hiv === "Yes" && state === ARIZONA) || (hivSubstantiated === "No" && hiv === "Yes") || ((state === OREGON || state === MARYLAND) && aids === "Yes" && ((hivSubstantiated === "No" && state === OREGON) || (state === MARYLAND && hivSubstantiated === "Yes" && hivSubstantiatedSevenYears === 'No'))) || (state === MAINE && aids === "No")) && hivReceiptPhysician === "Yes",
            then: string().required("Zip is required").matches(/^[0-9]{5}$/, 'Zip code must be 5 number characters.'),
            otherwise: string().notRequired()
        }),
        ineligible: mixed().when(['hiv', 'state', 'aids', ], {
            is: (hiv, state, aids) => ((hiv === 'Yes' && state === COLORADO) || (aids === 'Yes' && state === MAINE)),
            then: yuparray(
                object().shape({
                    name: string().required('Name is required.'),
                    numberOfChildren: string().when('name', {
                        is: (name) => name && name.includes('Dependent Child'),
                        then: string().required('This filed is required.'),
                        otherwise: string().notRequired(),
                    }),
                    nameofChildren: yuparray().when('name', {
                        is: (name) => name && name.includes('Dependent Child'),
                        then: yuparray(
                            object().shape({
                                name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
                            })
                        ),
                    }),
                })
            ),
            otherwise: mixed().notRequired()
        }),  
    })
};

HIVEligibility.DefaultFormState = (prefill = false) => {
    return {
        hiv: prefill ? '' : '',
        aids: prefill ? '' : '',
        hivPositive: prefill ? '' : '',
        hivSubstantiatedSevenYears: prefill ? '' : '',
        hivPositiveMultispot: prefill ? '' : '',
        hivSubstantiated: prefill ? "" : '',
        hivReceiptPhysician: prefill ? "" : '',
        ineligibleForCoverage: '',
        hivTestsPerformed: '',
        hivPhysicianName: '',
        hivPhysicianState: '',
        hivPhysicianCity: '',
        hivPhysicianStreet: '',
        hivPhysicianZip: '',
        hivReceiptPhysicianCity: '',
        hivReceiptPhysicianName: '',
        hivReceiptPhysicianState: '',
        hivReceiptPhysicianStreet: '',
        hivReceiptPhysicianZip: '',
        ineligible: [],
        hivTestsDate: null,
        anotherChild: "",
        isVisible: false
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/HIVEligibility.js